// Statik proje verileri — yeni proje eklemek için bu listeye yeni bir obje ekleyin.
// Görseller public/img/portfolio/ altında durur.
const projects = [
  {
    id: 7,
    title: 'Oligatto Olive Pits Cat Litter',
    description: 'Dust-free, biodegradable cat litter produced by upcycling olive pits — a by-product of our olive oil production.',
    image: '/img/portfolio/oligatto.jpg',
    hoverImage: '/img/portfolio/oligatto2.jpg',
    link: 'https://www.oligatto.com',
    github: '#',
    tags: ['Manufacturing', 'E-Commerce', 'R&D', 'Sustainability'],
  },
  {
    id: 1,
    title: 'Orfion Olive Oil',
    description: 'My personal Business website built with Wordpress and woocommerce e-commerce system.',
    image: '/img/portfolio/orfion.jpg',
    hoverImage: '/img/portfolio/orfion2.png',
    link: 'https://www.orfion.com.tr',
    github: 'https://github.com/0xOzgur',
    tags: ['Manufacturing', 'R&D', 'Wordpress', 'Woocommerce', 'Payment Gateway', 'SEO'],
  },
  {
    id: 2,
    title: 'Personal Website',
    description: 'My personal website built with React and styled-components.',
    image: '/img/portfolio/ou.jpg',
    hoverImage: '/img/portfolio/ou2.jpg',
    link: 'https://www.ozguruzden.com',
    github: 'https://github.com/0xOzgur/ozguruzden.com',
    tags: ['React', 'Styled Components', 'Responsive Design'],
  },
  {
    id: 3,
    title: 'Quilibrium Space',
    description: 'Quilibrium Documentation and Support Site.',
    image: '/img/portfolio/quilibrium1.jpg',
    hoverImage: '/img/portfolio/quilibrium2.jpg',
    link: 'https://quilibrium.space/',
    github: 'https://github.com/0xOzgur/quilibrium-space',
    tags: ['Next.js', 'Javascript', 'GitBook'],
  },
  {
    id: 4,
    title: 'Quilibrium Tools',
    description: 'A Bash script for Quilibrium Node runners that serve many basic tools.',
    image: '/img/portfolio/qdummies.png',
    hoverImage: '/img/portfolio/qdummies.png',
    link: 'https://github.com/0xOzgur/QuilibriumTools',
    github: 'https://github.com/0xOzgur/QuilibriumTools',
    tags: ['Bash', 'Go', 'gRPC', 'Linux'],
  },
  {
    id: 5,
    title: 'Tarhala Olive Oil',
    description: 'Web Site of Tarhala Olive Oil is brand that produce oils in both Turkiye and Greece.',
    image: '/img/portfolio/tarhala1.jpg',
    hoverImage: '/img/portfolio/tarhala2.jpg',
    link: 'https://www.tarhalazeytinyaglari.com/',
    github: 'https://github.com/0xOzgur',
    tags: ['Wordpress', 'Woocommerce', 'Payment Gateway'],
  },
  {
    id: 6,
    title: 'Anatolian Evoo Selection',
    description: 'Anatolian EVOO Selection offers premium extra virgin olive oils from diverse Anatolian olives.',
    image: '/img/portfolio/anatolian1.jpg',
    hoverImage: '/img/portfolio/anatolian3.jpg',
    link: 'https://www.anatolianevooselection.org',
    github: 'https://github.com/0xOzgur',
    tags: ['Wordpress', 'Styled Components', 'Responsive Design'],
  },
];

export default projects;
